export default "__VITE_ASSET__ffda4283__"